export default {"src":"/_next/static/media/linkedin.5d6bbedc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};